import React from "react";
import { HiOutlineNewspaper } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneNews } from "../../../lib/sysNavigation/SysNavigation";

type NewsRow = {
  news_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<NewsRow>
    type={_TYPES_.NEWS}
    title="News"
    subtitle="News articles promoted on the public site."
    icon={<HiOutlineNewspaper className="h-5 w-5" />}
    addRoute="/data/news/add"
    editRoute="/data/news/edit"
    pushOne={pushOneNews}
    dataKey="news"
    countKey="newsCount"
    idField="news_id"
    titleField="title"
  />
);

export default Overview;
